// extracted by mini-css-extract-plugin
module.exports = {"myCard":"row_myCard__Tu1dQ"};